import { network } from 'services/network';

export const getFilterReferencesOptions = (params) => {
    const url = 'api/bo/getFilterReferencesOptions';
    return network.post(url, params).then((response) => response.data);
};
